import { mediaQuery } from 'constants/ui';

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '24px',
  borderRadius: '8px',
  border: '1px solid',
  borderColor: ({ palette }) => palette.border.default,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const headerWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const fieldsWrapperStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '16px',

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
  },
};

export const fieldWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0,
};

export const checkboxFieldWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  minHeight: '40px',
};

export const actionsWrapperStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  marginTop: '8px',
};

export const recalculateConfirmationBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  width: '100%',
};

export const recalculateConfirmationActionsStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',
  width: '100%',
  marginTop: '8px',

  [mediaQuery.mobile]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
};
